import React, { FC, PropsWithChildren } from 'react'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import clsx from 'clsx'
import Card from 'core/elements/card'
import { CardProps } from 'core/elements/card/Card'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import Radio from 'core/elements/input/Radio'
import Checkbox from 'core/elements/input/Checkbox'
import { Tooltip } from '@material-ui/core'

// const useStyles = makeStyles<Theme, Partial<SelectableCardProps>>((theme) => ({
//   selectableCard: {
//     cursor: 'pointer',
//     border: ({ active }) =>
//       active
//         ? `1px solid ${theme.components.card.activeBorder}`
//         : `1px solid ${theme.components.card.border}`,
//     backgroundColor: ({ active }) =>
//       active ? theme.components.card.activeBackground : theme.components.card.background,
//     '&:hover': {
//       border: `1px solid ${theme.components.card.activeBorder}`,
//     },
//   },
// }))

const useStyles = makeStyles<Theme, Partial<SelectableCardProps>>((theme) => ({
  selectableCard: {
    position: 'relative',
  },
  card: {
    cursor: ({ disabled }) => (disabled ? 'not-allowed' : 'pointer'),
    border: ({ active }) =>
      active
        ? `1px solid ${theme.components.card.activeBorder}`
        : `1px solid ${theme.components.card.border}`,
    backgroundColor: ({ active, disabled }) =>
      active
        ? theme.components.card.activeBackground
        : disabled
        ? theme.components.iconButton.disabledBackground
        : theme.components.card.background,
    '&:hover': {
      border: ({ disabled }) =>
        disabled
          ? `1px solid ${theme.components.card.border}`
          : `1px solid ${theme.components.card.activeBorder}`,
    },
  },
  circle: {
    background: theme.components.card.activeBorder,
    position: 'absolute',
    right: '-7px',
    top: '-8px',
    borderRadius: '50%',
    width: '27px',
    height: '27px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  checkIcon: {
    color: 'white',
  },
  radioCard: {
    display: 'grid',
    gridTemplateColumns: 'max-content auto',
    gap: 8,
  },
  customTooltip: {
    backgroundColor: theme.components.tooltip.background,
    border: 'none',
    borderRadius: 4,
    color: theme.components.tooltip.text,
    width: 'max-content',
  },
}))

const SelectableCard: FC<PropsWithChildren<SelectableCardProps>> = (props) => {
  const {
    id,
    onClick,
    children,
    className = undefined,
    active,
    showCheckmarkIcon = false,
    showRadioButton = false,
    showCheckbox = false,
    disabled = false,
    tooltip = '',
    ...rest
  } = props
  const classes = useStyles({ active, disabled })

  const handleClick = () => {
    if (disabled) {
      return
    }
    if (onClick) return onClick(id)
  }
  // return (
  //   <div onClick={handleClick}>
  //     <Card {...rest} className={clsx(classes.selectableCard, className)}>
  //       {children}
  //     </Card>
  //   </div>
  // )

  return (
    <Tooltip title={tooltip} placement="top" classes={{ tooltip: classes.customTooltip }}>
      <div className={classes.selectableCard} onClick={handleClick}>
        <Card
          {...rest}
          className={clsx(
            classes.card,
            className,
            (showRadioButton || showCheckbox) && classes.radioCard,
          )}
        >
          {showRadioButton ? (
            <>
              <div>
                <Radio checked={active}></Radio>
              </div>
              <div>{children}</div>
            </>
          ) : showCheckbox ? (
            <>
              <div>
                <Checkbox textWeight="light" checked={active} />
              </div>
              <div>{children}</div>
            </>
          ) : (
            children
          )}
        </Card>
        {active && showCheckmarkIcon && (
          <div className={classes.circle}>
            <FontAwesomeIcon className={classes.checkIcon} solid size="sm">
              check
            </FontAwesomeIcon>
          </div>
        )}
      </div>
    </Tooltip>
  )
}

interface SelectableCardProps extends CardProps {
  id: any
  onClick: any
  active?: boolean
  className?: string
  showCheckmarkIcon?: boolean
  showRadioButton?: boolean
  showCheckbox?: boolean
  disabled?: boolean
  tooltip?: string
}

export default SelectableCard
